<template>
  <div>
    <div v-html="formattedDiff"></div>
  </div>
</template>

<script>
import * as jsondiffpatch from 'jsondiffpatch'
import "jsondiffpatch/dist/formatters-styles/annotated.css"
import "jsondiffpatch/dist/formatters-styles/html.css";

export default {
  props: {
    appData: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedDiff() {
      try {
        // Extract `oauthClient` for comparison
        let oauthClientData = this.appData.oauthClient

        // If the app is channging from private to public for the first time, `oauthClient` will be undefined
        if (!this.appData.private && this.appData.oauthClient && this.appData.oauthClient.private) {
          oauthClientData = {}
        }
        
        // Create a shallow copy of `appData` and exclude `oauthClient`
        const appDataWithoutOauthClient = { ...this.appData }
        delete appDataWithoutOauthClient.oauthClient

        // Initialize jsondiffpatch instance
        const diffpatcher = jsondiffpatch.create()

        // Compute the difference between appDataWithoutOauthClient and oauthClientData
        const delta = diffpatcher.diff(oauthClientData, appDataWithoutOauthClient)
        delete delta.dev

        // Format the delta as HTML if differences exist, otherwise show no changes
        return delta ? jsondiffpatch.formatters.html.format(delta) : '<p>No changes detected</p>'
      } catch (error) {
        console.error('Error generating diff:', error)
        return '<p>Error displaying diff</p>'
      }
    }
  }
}
</script>

<style scoped>
h3 {
  color: #333;
  margin-bottom: 10px;
}

.diff {
  font-family: Arial, sans-serif;
}

.added {
  color: green;
}

.removed {
  color: red;
}
</style>